import { render, staticRenderFns } from "./HoldingRepurchase.vue?vue&type=template&id=08e18253&scoped=true&"
import script from "./HoldingRepurchase.vue?vue&type=script&lang=js&"
export * from "./HoldingRepurchase.vue?vue&type=script&lang=js&"
import style0 from "./HoldingRepurchase.vue?vue&type=style&index=0&id=08e18253&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e18253",
  null
  
)

export default component.exports